"use client";

import { MessageSquare, Radio, BarChart3 } from "lucide-react";
import { FadeIn, HomeEyebrow, HomeHeading, HomeLead, HomeSection } from "~/components/siteglue/home/section-shell";
import {
  SITEGLUE_BASE_INCLUDED,
  SITEGLUE_BASE_PLAN_HELPER,
  SITEGLUE_BASE_PLAN_DISPLAY_NAME,
} from "~/lib/siteglue/base-plan";
import { SITEGLUE_PRODUCT_NAME } from "~/lib/siteglue/customer-terms";

const ICONS = [Radio, MessageSquare, BarChart3] as const;

export function SiteGlueHomeBasePlan() {
  return (
    <HomeSection id="base-plan" tone="slate">
      <FadeIn>
        <HomeEyebrow>One product</HomeEyebrow>
        <HomeHeading className="mt-4 text-4xl font-semibold sm:text-5xl">
          {SITEGLUE_BASE_PLAN_DISPLAY_NAME}
        </HomeHeading>
        <HomeLead>
          One Agent per organization. The base includes {SITEGLUE_BASE_INCLUDED.join(", ")}.
          Additional channels are optional. Team Handoff™ is included — not a priced channel.
        </HomeLead>
        <p className="mt-3 max-w-2xl text-sm text-slate-500">{SITEGLUE_BASE_PLAN_HELPER}</p>
      </FadeIn>
      <div className="mt-12 grid gap-5 sm:grid-cols-3">
        {SITEGLUE_BASE_INCLUDED.map((label, index) => {
          const Icon = ICONS[index] ?? Radio;
          return (
            <FadeIn
              key={label}
              delay={0.06 * (index + 1)}
              className="rounded-2xl border border-slate-200 bg-white p-6"
            >
              <Icon className="h-5 w-5 text-[#4f81bd]" aria-hidden />
              <h3 className="mt-4 text-lg font-semibold text-slate-900">{label}</h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-600">
                {label === "AI Agents"
                  ? "A documented interface so personal AI agents can find answers and take approved actions."
                  : label === "Live Chat"
                    ? "Website visitors can start a conversation without finishing every site fix first."
                    : `Built-in reporting for ${SITEGLUE_PRODUCT_NAME} — not a separate SKU.`}
              </p>
            </FadeIn>
          );
        })}
      </div>
    </HomeSection>
  );
}
